import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.market');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface NavItem {
    label: string;
    link: string;
    requiresAuth?: boolean;
    symbol: string;
}

interface InfoMenu {
    label: string;
    description: string;
    link: string;
    symbol: string;
}

@Component({
    selector: 'wiz-layout-market',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.market/view.scss */
:host {
  display: block;
  min-height: 100%;
}

* {
  box-sizing: border-box;
}

.market-layout-shell {
  min-height: 100vh;
  color: #182720;
  background: #f4f7f6;
}

.market-layout-content {
  min-height: 100vh;
  transition: filter 180ms ease;
}

.market-layout-content.is-blurred {
  filter: blur(3px);
}

.market-global-header {
  position: sticky;
  z-index: 50;
  top: 0;
  border-bottom: 1px solid rgba(216, 226, 222, 0.86);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 7px 28px rgba(19, 52, 46, 0.045);
  backdrop-filter: blur(18px);
}

.market-global-header-inner {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr) 330px;
  align-items: center;
  width: min(100% - 40px, 1248px);
  min-height: 70px;
  margin: 0 auto;
  gap: 16px;
}

.market-global-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  color: inherit;
  text-decoration: none;
}

.market-global-logo {
  display: inline-flex;
  align-items: center;
}
.market-global-logo img {
  width: auto;
  height: 40px;
  max-width: 120px;
  object-fit: contain;
}

.market-global-brand-copy {
  display: grid;
  gap: 2px;
  padding-left: 12px;
  border-left: 1px solid #dce5e1;
}
.market-global-brand-copy strong {
  color: #285c3a;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.16em;
}
.market-global-brand-copy small {
  color: #899690;
  font-size: 8px;
  white-space: nowrap;
}

.market-global-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}

.market-nav-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 10px;
  border: 0;
  border-radius: 10px;
  color: #55665f;
  text-decoration: none;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  transition: color 160ms ease, background 160ms ease;
}
.market-nav-item::after {
  position: absolute;
  right: 12px;
  bottom: 3px;
  left: 12px;
  height: 2px;
  border-radius: 999px;
  background: transparent;
  content: "";
}
.market-nav-item:hover {
  color: #215d3d;
  background: #f2f7f3;
}
.market-nav-item.is-active {
  color: #215d3d;
  background: #eff6ed;
}
.market-nav-item.is-active::after {
  background: linear-gradient(90deg, #78ad46, #2c7654);
}

.market-global-actions,
.market-account-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.market-account-actions {
  gap: 7px;
}

.market-history-button,
.market-account-button,
.market-login-button,
.market-signup-button,
.market-logout-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 39px;
  border-radius: 11px;
  text-decoration: none;
  font-size: 11px;
  font-weight: 750;
  transition: transform 150ms ease, border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}
.market-history-button:hover,
.market-account-button:hover,
.market-login-button:hover,
.market-signup-button:hover,
.market-logout-button:hover {
  transform: translateY(-1px);
}
.market-history-button svg,
.market-account-button svg,
.market-login-button svg,
.market-signup-button svg,
.market-logout-button svg {
  width: 17px;
  height: 17px;
}

.market-history-button,
.market-account-button,
.market-login-button {
  gap: 7px;
  max-width: 132px;
  padding: 0 12px;
  overflow: hidden;
  border: 1px solid #d7e2de;
  color: #41564e;
  background: #fff;
}
.market-history-button span,
.market-account-button span,
.market-login-button span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.market-history-button:hover,
.market-account-button:hover,
.market-login-button:hover {
  border-color: #a8c792;
  color: #316b39;
  background: #f7fbf4;
}

.market-history-button {
  flex: 0 0 auto;
  color: #285f40;
  border-color: #bcd5c5;
  background: #f0f7f2;
}
.market-history-button:hover {
  border-color: #7caf8d;
  color: #174f31;
  background: #e5f2e9;
}
.market-history-button.is-active {
  border-color: #1f7048;
  color: #fff;
  background: #1f7048;
}

.market-signup-button {
  padding: 0 14px;
  color: #fff;
  background: linear-gradient(145deg, #193f39, #102e2b);
  box-shadow: 0 7px 16px rgba(19, 61, 54, 0.15);
}

.market-logout-button {
  width: 39px;
  color: #7a8983;
}
.market-logout-button:hover {
  color: #335c4d;
  background: #f0f5f3;
}

.market-mobile-trigger {
  display: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #d7e2de;
  border-radius: 11px;
  color: #3f564d;
  background: #fff;
}
.market-mobile-trigger svg {
  width: 19px;
  height: 19px;
}

.market-mobile-panel {
  display: none;
}

.market-global-main {
  min-height: calc(100vh - 70px);
  background: radial-gradient(circle at 84% 3%, rgba(142, 188, 84, 0.09), transparent 23rem), linear-gradient(180deg, #f7f9f8, #f3f6f5 38rem, #f7f9f8);
}

.market-info-frame {
  display: grid;
  width: min(100% - 32px, 1380px);
  margin: 0 auto;
  padding: 26px 0 64px;
  gap: 20px;
  transition: grid-template-columns 180ms ease;
}
.market-info-frame.is-collapsed {
  grid-template-columns: 62px minmax(0, 1fr);
}
.market-info-frame.is-expanded {
  grid-template-columns: 222px minmax(0, 1fr);
}

.market-info-sidebar {
  position: sticky;
  z-index: 5;
  top: 96px;
  align-self: start;
}
.market-info-sidebar nav {
  overflow: hidden;
  padding: 12px 9px;
  border: 1px solid #dbe5e1;
  border-radius: 17px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 14px 35px rgba(25, 58, 52, 0.065);
  backdrop-filter: blur(15px);
}

.market-info-sidebar-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 39px;
  padding: 0 2px 10px;
  border-bottom: 1px solid #e7eeeb;
}
.market-info-sidebar-head > div {
  display: grid;
  gap: 3px;
  padding-left: 7px;
}
.market-info-sidebar-head > div span {
  color: #7e918a;
  font-size: 8px;
  font-weight: 850;
  letter-spacing: 0.16em;
}
.market-info-sidebar-head > div strong {
  color: #263a33;
  font-size: 12px;
  font-weight: 750;
}
.market-info-sidebar-head button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 10px;
  color: #4c685d;
  background: #f0f5f3;
  cursor: pointer;
}
.market-info-sidebar-head button svg {
  width: 16px;
  height: 16px;
}
.market-info-sidebar-head button:hover {
  color: #396d3c;
  background: #edf6e8;
}

.is-collapsed .market-info-sidebar-head {
  justify-content: center;
}

.market-info-links {
  display: grid;
  gap: 5px;
  padding-top: 10px;
}
.market-info-links a {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 14px;
  align-items: center;
  gap: 8px;
  min-height: 50px;
  padding: 7px;
  border-radius: 12px;
  color: #596b64;
  text-decoration: none;
  transition: color 160ms ease, background 160ms ease, transform 160ms ease;
}
.market-info-links a:hover {
  color: #2f6d38;
  background: #f0f7ec;
  transform: translateX(1px);
}

.is-collapsed .market-info-links a {
  grid-template-columns: 36px;
  justify-content: center;
  padding: 7px 4px;
}

.market-info-link-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 11px;
  color: #678078;
  background: #eef3f1;
}
.market-info-link-icon svg {
  width: 16px;
  height: 16px;
}

.market-info-link-copy {
  display: grid;
  min-width: 0;
  gap: 2px;
}
.market-info-link-copy strong {
  font-size: 11px;
  font-weight: 750;
}
.market-info-link-copy small {
  overflow: hidden;
  color: #94a09c;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.market-info-link-arrow {
  width: 13px;
  height: 13px;
  opacity: 0.35;
}

.market-info-outlet {
  min-width: 0;
}

.market-layout-auth-overlay,
.market-global-loading {
  position: fixed;
  z-index: 90;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(8, 28, 27, 0.58);
  backdrop-filter: blur(8px);
}

.market-layout-auth-modal {
  position: relative;
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  overflow: hidden;
  width: min(100%, 540px);
  min-height: 270px;
  border-radius: 23px;
  background: #fff;
  box-shadow: 0 34px 90px rgba(4, 27, 24, 0.3);
}

.market-layout-auth-close {
  position: absolute;
  z-index: 3;
  top: 14px;
  right: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  border: 0;
  border-radius: 10px;
  color: #76857f;
  background: #f1f5f3;
}
.market-layout-auth-close svg {
  width: 16px;
  height: 16px;
}

.market-layout-auth-visual {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: #d7edb7;
  background: radial-gradient(circle at 30% 25%, rgba(172, 217, 101, 0.3), transparent 8rem), linear-gradient(145deg, #123e37, #1c5b45);
}
.market-layout-auth-visual::before, .market-layout-auth-visual::after {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;
  content: "";
}
.market-layout-auth-visual::before {
  width: 170px;
  height: 170px;
}
.market-layout-auth-visual::after {
  width: 118px;
  height: 118px;
}
.market-layout-auth-visual > span {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 62px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.1);
}
.market-layout-auth-visual > span svg {
  width: 28px;
  height: 28px;
}
.market-layout-auth-visual small {
  position: relative;
  z-index: 1;
  margin-top: 14px;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.18em;
}

.market-layout-auth-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 38px 34px 30px;
}
.market-layout-auth-content > span {
  color: #5c8b40;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.1em;
}
.market-layout-auth-content h2,
.market-layout-auth-content p {
  margin: 0;
}
.market-layout-auth-content h2 {
  margin-top: 8px;
  color: #192823;
  font-size: 21px;
  font-weight: 780;
  letter-spacing: -0.035em;
}
.market-layout-auth-content p {
  margin-top: 11px;
  color: #71807b;
  font-size: 11px;
  line-height: 1.7;
  word-break: keep-all;
}
.market-layout-auth-content > div {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 7px;
  margin-top: 22px;
}
.market-layout-auth-content > div button {
  height: 40px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 750;
}
.market-layout-auth-content > div button:first-child {
  border: 1px solid #17473e;
  color: #fff;
  background: #17473e;
}
.market-layout-auth-content > div button:last-child {
  border: 1px solid #d8e2de;
  color: #50635d;
  background: #fff;
}

@media (max-width: 1100px) {
  .market-global-header-inner {
    grid-template-columns: 150px minmax(0, 1fr) 270px;
  }
  .market-global-brand-copy {
    display: none;
  }
  .market-nav-item {
    padding: 0 7px;
    font-size: 11px;
  }
}
@media (max-width: 900px) {
  .market-global-header-inner {
    grid-template-columns: 1fr auto;
    min-height: 64px;
  }
  .market-global-nav,
  .market-account-actions {
    display: none;
  }
  .market-mobile-trigger {
    display: inline-flex;
  }
  .market-mobile-panel {
    display: block;
    padding: 12px 16px 16px;
    border-top: 1px solid #e2e9e6;
    background: rgba(255, 255, 255, 0.98);
  }
  .market-mobile-panel nav {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
  }
  .market-mobile-panel nav a,
  .market-mobile-panel nav button {
    min-height: 42px;
    padding: 0 12px;
    border: 0;
    border-radius: 10px;
    color: #43574f;
    text-align: left;
    text-decoration: none;
    background: #f3f6f5;
    font-size: 11px;
    font-weight: 700;
  }
  .market-mobile-account {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #e5ebe9;
  }
  .market-mobile-account > div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 7px;
  }
  .market-mobile-account > div a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 40px;
    border: 1px solid #dce4e1;
    border-radius: 10px;
    color: #465a52;
    text-decoration: none;
    background: #fff;
    font-size: 10px;
    font-weight: 700;
  }
  .market-mobile-account > div a:last-child {
    border-color: #193f39;
    color: #fff;
    background: #193f39;
  }
  .market-info-frame {
    display: block;
    width: min(100% - 24px, 100%);
    padding-top: 14px;
  }
  .market-info-sidebar {
    position: static;
    margin-bottom: 14px;
  }
  .market-info-sidebar nav {
    padding: 8px;
  }
  .market-info-sidebar-head {
    display: none;
  }
  .market-info-links {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    padding: 0;
  }
  .market-info-links a, .is-collapsed .market-info-links a {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 42px;
    padding: 4px;
  }
  .market-info-link-copy,
  .market-info-link-arrow {
    display: none;
  }
  .market-info-link-icon {
    width: 34px;
    height: 34px;
  }
}
@media (max-width: 560px) {
  .market-global-header-inner {
    width: min(100% - 24px, 100%);
  }
  .market-global-logo img {
    height: 36px;
  }
  .market-layout-auth-modal {
    grid-template-columns: 1fr;
    max-width: 380px;
  }
  .market-layout-auth-visual {
    min-height: 115px;
  }
  .market-layout-auth-content {
    padding: 27px 23px 24px;
  }
}
.market-global-brand-copy strong {
  font-size: 18px;
  letter-spacing: -0.03em;
}

.market-global-brand-copy small {
  font-size: 9px;
}

.market-global-logo img {
  height: 49px;
  width: 41px;
}

@media (max-width: 767px) {
  .market-global-brand-copy strong {
    font-size: 16px;
  }
  .market-global-logo img {
    height: 43px;
    width: 36px;
  }
}
.market-nav-item {
  gap: 6px;
}

.market-mobile-panel nav a, .market-mobile-panel nav button {
  display: flex;
  align-items: center;
  gap: 10px;
}

.market-info-link-icon {
  padding: 0;
  background: transparent;
}

.market-info-link-icon img {
  display: block;
  width: 38px;
  height: 38px;
}`],
})
export class LayoutMarketComponent implements OnInit {
    public navOpen: boolean = false;
    public authModalOpen: boolean = false;
    public authActionLabel: string = '회원 전용 기능';
    public marketInfoMenuCollapsed: boolean = false;
    public navItems: NavItem[] = [
        { label: '전체 사건', symbol: 'cases', link: '/market/cases' },
        { label: '판매등록', symbol: 'sell', link: '/sell', requiresAuth: true },
        { label: '자유 상담', symbol: 'consult', link: '/qna', requiresAuth: true },
        { label: 'AI검색(구매)', symbol: 'ai', link: '/search/ai', requiresAuth: true },
        { label: '기술가치평가', symbol: 'valuation', link: '/valuation', requiresAuth: true }
    ];
    public infoMenus: InfoMenu[] = [
        {
            label: '공지사항',
            description: '거래소 운영 공지',
            link: '/market/info/notice',
            symbol: 'notice'
        },
        {
            label: '이용절차',
            description: '판매·구매 진행 단계',
            link: '/market/info/process',
            symbol: 'process'
        },
        {
            label: '사업정보',
            description: '지원사업과 IP 소식',
            link: '/market/info/business',
            symbol: 'business'
        },
        {
            label: '회원소식',
            description: '회원사 홍보와 업데이트',
            link: '/market/info/member-news',
            symbol: 'member-news'
        }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public get userName() {
        const auth = this.service.auth;
        const session = auth && auth.session ? auth.session : {};
        return session.name || session.email || '회원';
    }

    public isAuthenticated() {
        try {
            const auth = this.service.auth;
            if (!auth || !auth.check) return false;
            return !!auth.check();
        } catch (error) {
            return false;
        }
    }

    public async toggleNav() {
        this.navOpen = !this.navOpen;
        await this.service.render();
    }

    public async closeNav() {
        this.navOpen = false;
        await this.service.render();
    }

    public async toggleMarketInfoMenu() {
        this.marketInfoMenuCollapsed = !this.marketInfoMenuCollapsed;
        await this.service.render();
    }

    public showMarketInfoMenu() {
        const path = this.normalizePath(location.pathname);
        return path.indexOf('/market/info/') === 0
            || path === '/market/cases'
            || path === '/sell'
            || path === '/consult'
            || path.indexOf('/consult/') === 0
            || path === '/qna'
            || path === '/search/ai'
            || path.indexOf('/search/ai/') === 0
            || path === '/valuation'
            || path === '/my-consultations';
    }

    public async openProtectedAction(item: NavItem) {
        this.navOpen = false;
        const loggedIn = await this.isLoggedIn();
        if (loggedIn) {
            location.href = item.link;
            return;
        }

        this.authActionLabel = item.label;
        this.authModalOpen = true;
        await this.service.render();
    }

    public async closeAuthModal() {
        this.authModalOpen = false;
        await this.service.render();
    }

    public goLogin() {
        location.href = '/access';
    }

    public goSignup() {
        location.href = '/access?view=signup';
    }

    public isActive(item: NavItem) {
        const path = this.normalizePath(location.pathname);
        if (path === '/' || path === '/market') return false;

        const link = this.normalizePath(item.link);
        return path === link || path.indexOf(`${link}/`) === 0;
    }

    public activeClass(item: NavItem) {
        return this.isActive(item) ? 'market-nav-item is-active' : 'market-nav-item';
    }

    private async isLoggedIn() {
        try {
            await this.service.auth.update();
            return this.isAuthenticated();
        } catch (error) {
            return false;
        }
    }

    private normalizePath(path: string) {
        const normalized = (path || '/').replace(/\/+$/, '');
        return normalized || '/';
    }
}

export default LayoutMarketComponent;